export function formatarData(data) {
    if (!data) return '-';
    const d = new Date(data);
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
}

export function extrairNumeros(texto) {
    if (!texto) return '';
    return texto.replace(/\D/g, '');
}

export function paraDataIso(valor) {
    if (valor == null || valor === '') return null;
    const texto = String(valor).trim();
    const isoDia = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDia) return `${isoDia[1]}-${isoDia[2]}-${isoDia[3]}`;
    const isoMes = texto.match(/^(\d{4})-(\d{2})$/);
    if (isoMes) return `${isoMes[1]}-${isoMes[2]}-01`;
    const br = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (br) return `${br[3]}-${br[2]}-${br[1]}`;
    return null;
}

const PRIMEIRO_ACENTO_UNICODE = 0x0300;
const ULTIMO_ACENTO_UNICODE = 0x036f;

function ehAcento(caractere) {
    const codigo = caractere.charCodeAt(0);
    return codigo >= PRIMEIRO_ACENTO_UNICODE && codigo <= ULTIMO_ACENTO_UNICODE;
}

export function normalizarParaBusca(texto) {
    if (texto === null || texto === undefined) return '';
    return String(texto)
        .normalize('NFD')
        .split('')
        .filter((caractere) => !ehAcento(caractere))
        .join('')
        .toLowerCase()
        .trim();
}

export function opcoesDoEnum(enumerado) {
    return enumerado.map(({ id, descricao }) => ({ value: id, label: descricao }));
}

export function extrairPrefixoEmail(email) {
    if (!email) return 'UsuÃ¡rio';
    const posicaoArroba = email.indexOf('@');
    if (posicaoArroba > 0) return email.substring(0, posicaoArroba);
    return email;
}

export function formatarString(texto) {
    if (!texto) return '-';
    return texto.length > 25 ? texto.substring(0, 25) + '...' : texto;
}

export function formatarDocumento(cpfCnpj) {
    if (!cpfCnpj) return '-';
    const numeros = extrairNumeros(cpfCnpj);
    if (numeros.length === 11) {
        return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    if (numeros.length === 14) {
        return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return cpfCnpj;
}

export function aplicarMascaraCpf(texto) {
    const digitos = extrairNumeros(texto).slice(0, 11);
    if (digitos.length > 9) {
        return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6, 9)}-${digitos.slice(9)}`;
    }
    if (digitos.length > 6) {
        return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6)}`;
    }
    if (digitos.length > 3) {
        return `${digitos.slice(0, 3)}.${digitos.slice(3)}`;
    }
    return digitos;
}

export function aplicarMascaraCep(texto) {
    const digitos = extrairNumeros(texto).slice(0, 8);
    if (digitos.length > 5) {
        return `${digitos.slice(0, 5)}-${digitos.slice(5)}`;
    }
    return digitos;
}

export function aplicarMascaraTelefone(texto) {
    const digitos = extrairNumeros(texto).slice(0, 11);
    if (digitos.length > 10) {
        return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
    }
    if (digitos.length > 6) {
        return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
    }
    if (digitos.length > 2) {
        return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`;
    }
    if (digitos.length > 0) {
        return `(${digitos}`;
    }
    return digitos;
}

export function aplicarMascaraRg(texto) {
    if (!texto) return '';
    const limpo = texto.toUpperCase().replace(/[^0-9X]/g, '').slice(0, 9);
    if (limpo.length > 8) {
        return `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5, 8)}-${limpo.slice(8)}`;
    }
    if (limpo.length > 5) {
        return `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5)}`;
    }
    if (limpo.length > 2) {
        return `${limpo.slice(0, 2)}.${limpo.slice(2)}`;
    }
    return limpo;
}

export function aplicarMascaraCrm(texto) {
    return extrairNumeros(texto).slice(0, 10);
}

export function cpfEhValido(cpf) {
    const digitos = extrairNumeros(cpf);
    if (digitos.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(digitos)) return false;

    const calcularDigitoVerificador = (base, pesoInicial) => {
        const soma = base
            .split('')
            .reduce((acumulado, caractere, posicao) => acumulado + Number(caractere) * (pesoInicial - posicao), 0);
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const primeiroDigito = calcularDigitoVerificador(digitos.slice(0, 9), 10);
    const segundoDigito = calcularDigitoVerificador(`${digitos.slice(0, 9)}${primeiroDigito}`, 11);

    return digitos.endsWith(`${primeiroDigito}${segundoDigito}`);
}

export function removerFormatacaoCpfCnpj(termo) {
    if (!termo) return termo;
    const padraoCpf = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
    const padraoCnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
    if (padraoCpf.test(termo) || padraoCnpj.test(termo)) {
        return extrairNumeros(termo);
    }
    return termo;
}

export function formatarStatus(codigo) {
    const mapa = {
        1: 'Em andamento',
        2: 'Deferida',
        3: 'Indeferida',
        4: 'Homologada',
        5: 'Eliminada',
    };
    return mapa[codigo] || 'Desconhecido';
}

export function formatarTelefones(item) {
    if (!item || !item.telefones || !item.telefones.length) return '-';
    return item.telefones.map(t => t.telNumero).join(' / ');
}

export function formatarCodigo(codigo) {
    if (codigo === null || codigo === undefined) return '-';
    return codigo < 10 ? `0${codigo}` : String(codigo);
}

export function convertStringToDate(str) {
    if (!str) return null;
    const [ano, mes, dia] = str.split('-').map(Number);
    return new Date(ano, mes - 1, dia);
}

export function convertDateToString(date) {
    if (!date) return '';
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
}

export function fazerDownloadArquivo(url, nomeArquivo) {
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo || 'arquivo';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function formatarMoeda(valor) {
    if (valor === null || valor === undefined) return '-';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
}
